<template>
    <RemoteTable ref="table" :form="form" :table="table">
        <template #default="{row, property}">
            <el-switch v-if="property === 'status'"
                       v-model="row.status.value" @change="changeStatus(row.id, $event)"
                       active-value="enable" inactive-value="disable"></el-switch>
        </template>
    </RemoteTable>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'
    import JSEncrypt from "jsencrypt";

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: this.getFormConfig(),
                table: {
                    urlPrefix: "/customer",
                    columns: [
                        {label: "账号", name: "account", width: 130},
                        {label: "部门名称", name: "companyName"},
                        {label: "联系人", name: "contactName", width: 100},
                        {label: "联系电话", name: "contactPhone", width: 120},
                        {label: "状态", name: "status", width: 80},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    tools: [
                        {
                            icon: "el-icon-refresh-right", content: "重置密码", click: (row) => {
                                this.$prompt('请输入新密码', '重置登录密码', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    inputPattern: /^\S{6,20}$/,
                                    inputErrorMessage: '密码长度在 6 到 20 个字符'
                                }).then(({ value }) => {
                                    this.$utils.post("/customer/resetpass", {
                                        id: row.id,
                                        pwd: this.encrypt(value)
                                    }, () => {
                                        this.$message.success("登录密码已重置！");
                                    })
                                });
                            }
                        }
                    ],
                    primaryColumns: [
                        {name: "account"}
                    ],
                    disableDelete: true
                }
            }
        },
        methods: {
            getFormConfig() {
                if (!this.$root.isAdmin) {
                    return null;
                }

                return {
                    configs: [
                        {label: "账号", name: "account", type: "input", op: "contains", value: ""},
                        {label: "部门名称", name: "companyName", type: "input", op: "contains", value: ""},
                        {label: "状态", name: "status", type: "select", value: "", url: "/dict/list/public/status"},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.$router.push("/customer/0")
                            }
                        },
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.get("/customer/download").then((response) => {
                                  this.$utils.download("/file/pop/" + response);
                                })
                              });
                            }
                        }
                    ]
                }
            },
            changeStatus(id, status) {
                this.$axios.post("/customer/edit", {
                    id: id,
                    status: {value: status}
                }).then((result) => {
                    this.$utils.handleResult(result, () => {
                        this.$refs.table.load();
                    })
                })
            },
            encrypt(text) {
                const publicKty = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjDMAZ8dLWV8zxzvDBDeJRYVGqyfhhauAZfl3eF6xnRcJjMadDW8CNPKqYSl5sLtqV8vbQdO1gJLYDOAwjEahkZnf1ftHjM7tFyQlWrUMqyPEmNRtPiJd//7ybitGdJ/VkaHI65qA/DkN5q+u523G3jK+1CdGp5UCcImqIZAwIx2pR8ZN7NyXoAcau+XbG2tFAp5A4FBhEjcJn6nDUzJiqqF6p1VpD9csi/45L5v6ruxy/oao5LrC22GImvI7rMRawXRy3u/k1VQZEN7dzl91wbZzBIdBjebfdTFWOdHpiPbBSYu9xihoT9csG0ZNA3LKR203xFkWEoz+pQq89KHpBwIDAQAB";
                const encrypt = new JSEncrypt();
                encrypt.setPublicKey(publicKty);
                return encrypt.encrypt(text);
            }
        }
    }
</script>